var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.803 70.3302C58.2385 70.7631 143.168 68.685 152.951 64.6161",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2646 65.3082L26.7238 73.2732",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0002 65.3091C82.5073 60.8937 131.306 57.7767 155.981 60.5463C151.271 67.6104 142.648 75.7257 138.926 78.9L26.2913 78.4671L24.3 73.2732H57.8912",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.981 60.5472C119.878 63.7512 66.6349 65.3955 29.9271 65.3955L33.823 59.7684L45.1643 57.4308L51.0514 48.1673C47.7039 46.8398 41.7705 43.8731 44.818 42.6265C48.6273 41.0681 70.6173 40.7219 78.236 41.501C84.3309 42.1244 93.7908 49.8122 97.7157 52.5827C105.16 51.9767 118.234 51.5096 125.852 52.5827C131.999 53.4484 137.597 57.5174 141.003 59.5952",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0307 52.7387L58.672 46.3665H66.6184V52.7387H55.0307Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4785 52.7387L84.7419 46.3665H69.0765V52.7387H93.4785Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6263 55.3699H78.254V58.1061H84.6263V55.3699Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6294 55.3699H87.2571V58.1061H93.6294V55.3699Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.634 55.3699H96.2613V58.1061H102.634V55.3699Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.265 55.3699H108.488C110.07 55.3699 111.388 56.5696 111.605 58.106H105.265V55.3699Z",
    stroke: "black",
    strokeOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoat);
export default __webpack_public_path__ + "static/media/boat.eb428ec38a495cbfed8b5493c7b19257.svg";
export { ForwardRef as ReactComponent };